import { DayOfYearChartReportModel } from "@agroyaar/sdk";
import LineChart from "@/shared/components/charts/LineChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import { formatShowNumber } from "@/features/reports/presentation/components/cropping-pattern/utils/temperature-risk-charts";

interface DailyTemperatureChangeProps {
  dailyMaximumTemperatureChange: DayOfYearChartReportModel[];
  dailyMinimumTemperatureChange: DayOfYearChartReportModel[];
  dailyMeanTemperatureChange: DayOfYearChartReportModel[];
}

const DailyTemperatureChange = ({
  dailyMaximumTemperatureChange,
  dailyMeanTemperatureChange,
  dailyMinimumTemperatureChange,
}: DailyTemperatureChangeProps) => {
  const dayOfYears = dailyMeanTemperatureChange?.map((t) =>
    t.dayOfYear.toString()
  );

  const series = [
    {
      name: "حداکثر دما",
      data: dailyMaximumTemperatureChange?.map((t) => t.value),
    },
    {
      name: "میانگین دما",
      data: dailyMeanTemperatureChange?.map((t) => t.value),
    },
    {
      name: "حداقل دما",
      data: dailyMinimumTemperatureChange?.map((t) => t.value),
    },
  ];

  const minMax = (arr: DayOfYearChartReportModel[]) => {
    const values = arr?.map((t) => t.value);
    return { min: Math.min(...values), max: Math.max(...values) };
  };

  const minTemp = minMax(dailyMinimumTemperatureChange);
  const maxTemp = minMax(dailyMaximumTemperatureChange);
  const meanTemp = minMax(dailyMeanTemperatureChange);

  const noteText = `
    روند میانگین تغییرات دما در سه دهه گذشته نشان می‌دهد که
    محدوده دمای حداقل از حدود ${formatShowNumber(
      +minTemp?.min.toFixed(0)
    )} تا ${minTemp?.max.toFixed(0)} درجه سانتی‌گراد،
    دمای حداکثر از حدود ${maxTemp?.min.toFixed(0)} تا ${maxTemp?.max.toFixed(
    0
  )} درجه سانتی‌گراد
    و متوسط دما بین تقریباً ${meanTemp?.min.toFixed(
      0
    )} تا ${meanTemp?.max.toFixed(0)} درجه سانتی‌گراد متغیر بوده است.
  `;

  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={5}>
      <div className="w-full flex flex-col gap-3">
        <Title>روند تغییرات دمای روزانه بر اساس میانگین 30 سال گذشته</Title>
        <div className="w-full flex flex-col justify-center items-center gap-4 my-10">
          <LineChart
            yAxisTitle="(درحه سانتی گراد)دما"
            xAxisTitle="روز در سال"
            xAxisLabelsOptionsStep={30}
            labelsFontSize="10px"
            categories={dayOfYears}
            series={series}
          />

          <Title>
            روند تغییرات حداقل، حداکثر و متوسط دمای روزانه بر اساس میانگین 30
            سال گذشته ایستگاه
          </Title>
        </div>
      </div>
      <NoteBox>{noteText}</NoteBox>
    </ReportTemplate>
  );
};

export default DailyTemperatureChange;
